var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCovidMedicalMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#covid-medical-mask_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.18 15.88a1.098 1.098 0 00-1.554-.003l-3.454 3.438v-6.872l4.994-4.993a1.096 1.096 0 000-1.554 1.098 1.098 0 00-1.554 0L25.62 10.89H7.38l-4.94-4.941A1.098 1.098 0 10.887 7.502l4.94 4.941v6.872l-3.453-3.438a1.099 1.099 0 10-1.55 1.557l5.318 5.293c.03.031.062.06.096.088A16.44 16.44 0 0016.5 26.426c3.72 0 7.364-1.282 10.263-3.611v-.001c.03-.024.059-.05.087-.077l5.327-5.303a1.095 1.095 0 00.004-1.554zM8.025 21.42v-8.333h16.95v8.333a14.032 14.032 0 01-8.476 2.81 14.03 14.03 0 01-8.474-2.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.809 17.56h-1.21v-1.21a1.099 1.099 0 10-2.198 0v1.21h-1.21a1.099 1.099 0 100 2.197h1.21v1.21a1.099 1.099 0 002.198 0v-1.21h1.21a1.098 1.098 0 100-2.198z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "covid-medical-mask_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(.5)",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgCovidMedicalMask;